export const CONSIGNMENT_ICON_TEST_ID = 'ConsignmentIcon';
export const CONSIGNMENT_ICON_VALUE_TEST_ID = 'ConsignmentIconValue';
